<template>
  <div class="box">
    <ul class="list-box" style="width: 972px;margin: 0 auto;">
      <li
        @click="showTeacher(i)"
        :key="i"
        :class="[i!==0 && (i+1)%5 === 0? 'no-margin-right' : '']"
        v-for="(item,i) in dataInfo">
        <div
          class="avatar"
          v-lazy:background-image="`${item.uIcon == null ? defaultImage : item.uIcon}`"
          ></div>
        <div class="content" style="text-align: center;">
          <p>
            <span>{{item.uName}}</span>
          </p>
          <p>
            {{item.uOrg}}
          </p>
          <p>
            {{item.uTitle}}
          </p>
        </div>
      </li>
    </ul>
    <div style="text-align: center;" v-html="info.cpnContent"></div>
    <transition name="fade">
      <div @click="close" class="cover" v-show="showFl"></div>
    </transition>
    <transition name="bunce2">
      <div class="contain-box" v-show="showFl">
        <div>
          <div style="width: 100%;">
            <!--v-lazy:background-image="`${curTeacher.uIcon == null ? defaultImage : curTeacher.uIcon}`"-->
            <div
              class="avatar-box"
              style="display: inline-block;vertical-align: top;border: 1px solid #dedede;">
              <img :src="curTeacher.uIcon == null ? defaultImage : curTeacher.uIcon" alt="" style="width: 100%;height: 100%"/>
            </div>
            <div class="curteacher" style="display: inline-block;width: 510px;font-size: 16px;">
              <p>
                <span style="margin-right: 30px;font-size: 18px;">{{curTeacher.uName}}</span>
                <span>{{curTeacher.uTitle}}</span>
              </p>
              <p>
                {{curTeacher.uOrg}}
              </p>
            </div>
          </div>
          <div style="margin-top: 30px;font-size: 14px;height: 245px;overflow: auto;line-height: 1.8em;" v-html="curTeacher.uDesc">
          </div>
        </div>
        <a @click="close" class="close"><img src="./close.png" alt=""></a>
      </div>
    </transition>

  </div>
</template>
<script>
  export default{
    data(){
      return {
        activeTeacher: 0,
        showFl: 0,
        showFl2: 0,
        defaultImage: 'http://medcircle-test.oss-cn-beijing.aliyuncs.com/upload/icon/user_default.png'
      }
    },
    props: {
      info: {
        type: Object
      },
      dataInfo: {
        type: Array
      },
      col: {
        type: String
      },
      spanCol: {
        type: String
      }
    },
    computed: {
      teacher(){
        console.log(this.dataInfo);
        let tempArr = [];
        let number = this.col;
        let nums = Math.ceil(this.dataInfo.length / number);
        for (let i = 0; i < nums; i++) {
          tempArr.push(this.dataInfo.splice(0, number));
        }
        console.log(tempArr);
        return tempArr;
      },
      curTeacher(){
        return this.dataInfo[this.activeTeacher]
      }
    },
    methods: {
      showTeacher(index){
        this.activeTeacher = index;
        this.showFl = 1;
        this.showFl2 = 1;
      },
      close(){
        this.showFl = 0;
        setTimeout(()=>{
            this.showFl2 = 0;
        },500)
      }
    },
  }
</script>
<style lang="less" scoped>
  .list-box {
    /*width: 1100px;*/
    margin: 0 auto;
    text-align: center;
    li {
      border: 1px solid #ACACAC;
      float: left;
      width: 182px;
      height: 200px;
      margin-bottom: 15px;
      margin-right: 15px;
      padding-top: 10px;
      padding-left: 5px;
      padding-right: 5px;
      cursor: pointer;
      overflow: hidden;
    }
    .no-margin-right {
      margin-right: 0;
    }
    .content {
      margin-top: 12px;
      width: 100%;
      p{
        white-space: nowrap;
        overflow: hidden;
        text-overflow:ellipsis;
      }
    }
    &:after {
      content: '';
      display: block;
      clear: both;
    }
  }

  .avatar {
    display: inline-block;
    width: 100px;
    height: 100px;
    line-height: 1;
    overflow: hidden;
    background-position: center;
    background-size: cover;
    border-radius: 50%;
    border: 1px solid #dcdcdc;
    &[lazy=loading]{
      width: 20px;
      height: 20px;
    }
  }

  .cover {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 40;
  }

  .contain-box {
    background: #ffffff;
    color: #000000;
    width: 700px;
    height: 450px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 12px;
    box-shadow: 0 0 44px rgba(0, 0, 0, .8);
    padding: 25px;
    z-index: 900;
  }

  .avatar-box {
    width: 120px;
    height: 120px;
    background-position: center;
    background-size: cover;
    overflow: hidden;
    border-radius: 50%;
  }

  .curteacher {
    padding-top: 12px;
    padding-left: 20px;
    p {
      font-size: 16px;
      line-height: 30px;
    }
  }

  .close {
    position: absolute;
    right: 20px;
    top: 20px;
  }

  .bunce2-enter-active {
    animation: bounce112 .5s;
  }

  .bunce2-leave-active {
    animation: bounce112 .5s reverse;
  }

  @keyframes bounce112 {
    0%{
      top: -100%;
    }
    70%{
     top: 65%;
    }
    100%{
      top: 50%;
    }
  }
  .point{position: relative; line-height: 25px; max-height: 250px;overflow: hidden;}
  .point::after{content: "..."; position: absolute; bottom: 0; right: 0; padding-left: 40px;
    background: -webkit-linear-gradient(left, transparent, #fff 55%);
    background: -o-linear-gradient(right, transparent, #fff 55%);
    background: -moz-linear-gradient(right, transparent, #fff 55%);
    background: linear-gradient(to right, transparent, #fff 55%);
  }

</style>



// WEBPACK FOOTER //
// iTeacher.vue?300c2974